import { render, staticRenderFns } from "./CreateBankTransfer.vue?vue&type=template&id=938dec86"
import script from "./CreateBankTransfer.vue?vue&type=script&lang=js"
export * from "./CreateBankTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports